import { fetchSession } from '../api';
import { setItem } from '../utils/storage';
import isDemo from '../utils/is_demo';

export function checkAuth(window, fetchSession, setItem, isDemo) {
  return async function execute(returnPath) {
    if (isDemo() === true) return true;
    const session = await fetchSession();
    if (session) { return true; }
    if (returnPath && returnPath.length > 0) setItem('returnPath', returnPath);
    window.location = '/signin';
    return false;
  };
}

export default checkAuth(
  window,
  fetchSession,
  setItem,
  isDemo,
);
